import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../../../css/public/pricing.css';
import Cookies from 'js-cookie';
import { Select, MenuItem, FormControl, InputLabel, InputBase, Box, Typography } from '@mui/material';
import axios from 'axios';


const WhatsappMarketingPlans = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const [selectedPlanIdPro, setselectedPlanIdPro] = useState("PRO001");

  const [selectedPlanIdUltimate, setselectedPlanIdUltimate] = useState("ULT001");

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  
  
  const CookieAccountId = Cookies.get('current_accountId');
  const CurrentPlanId = Cookies.get('CurrentPlanId');

  const [PlanCurrency, setPlanCurrency] = useState("₹");
  const [PlanPriceLevel1, setPlanPriceLevel1] = useState("2,699");
  const [PlanPriceCheckPoint, setPlanPriceCheckPoint] = useState("6,829");
  const [PlanPricePowerMode, setPlanPricePowerMode] = useState("9,599");
  const [PlanDuration, setPlanDuration] = useState("Quarterly");
  const [UtilityPrice, setUtilityPrice] = useState("0.125");
  const [AuthenticationPrice, setAuthenticationPrice] = useState("0.125");
  const [MarketingPrice, setMarketingPrice] = useState("0.88");
  

  const SelectProPlan = async () => {
	Cookies.set('selected_plan_id', selectedPlanIdPro, { expires: 1 });
	Cookies.set('selected_plan_type', "EmailMarketing", { expires: 1 });
	const CookieSelectedPlanId = Cookies.get('selected_plan_id');
	window.location.href = `/checkout`;
  };
  
  const SelectUltimatePlan = async () => {
	Cookies.set('selected_plan_id', selectedPlanIdUltimate, { expires: 1 });
	Cookies.set('selected_plan_type', "EmailMarketing", { expires: 1 });
	const CookieSelectedPlanId = Cookies.get('selected_plan_id');
	window.location.href = `/checkout`;
  };

  useEffect(() => {
	if(CurrentPlanId === "BASIC00")	{
		setisBasicButtonDisabled(true);
	}else if(CurrentPlanId === "PRO001")	{
		setisProButtonDisabled(true);
	}else if(CurrentPlanId === "ULT001")	{
		setisUltimateButtonDisabled(true);
	}
	
	if (CurrentPlanId !== "" && CurrentPlanId !== "null" && CurrentPlanId !== undefined) {
		setisBasicButtonDisabled(true);
	}
	

  }, []);


  const faqs = [
    {
      question: "Are there any setup or hidden fees?",
      answer: "No, Aadow has transparent pricing with no hidden charges or setup fees."
    },
    {
      question: "Do I need to sign a long-term contract?",
      answer: "No, Aadow offers flexible monthly and annual subscriptions without long-term commitments."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept major credit/debit cards and online payment systems for your convenience."
    },
    {
      question: "Are there discounts for annual subscriptions?",
      answer: "Yes, annual plans come with exclusive discounts compared to monthly billing."
    },
    {
      question: "How do I switch to a different currency for payments?",
      answer: "You can choose your preferred currency during checkout, depending on your region."
    },
    {
      question: "Will I be charged automatically at the end of my billing cycle?",
      answer: "No, subscriptions are not automatically renewed."
    },
    {
      question: "Does Aadow offer nonprofit or educational discounts?",
      answer: "Yes, we have special pricing for nonprofits and educational institutions. Reach out to us for eligibility details."
    },
    {
      question: "Are there charges for team member accounts?",
      answer: "Team member access is included in specific plans. Additional charges may apply for extra users depending on your plan."
    },
    {
      question: "Does Aadow offer custom pricing for large businesses or high-volume senders?",
      answer: "Yes, Aadow provides tailored pricing plans for enterprises or high-volume email requirements. Contact our sales team for more details."
    },
    {
      question: "What happens if I exceed my plan's email limit?",
      answer: "If you exceed your plan’s limit, you can purchase additional credits or upgrade to a higher plan."
    }
  ];
  
  const [currencyselectedOption, currencysetSelectedOption] = useState('INR');
  const [value, setValue] = useState(0); // initial value set to 0
  
  
    // Define the specific steps you want for the slider
    const steps = [20000, 40000, 60000, 80000, 100000, 150000, 200000, 250000];
    const maxValue = steps.length - 1; // max value for the slider

   
	
	const RangedCredits = steps[value].toLocaleString('en-IN');
    useEffect(() => {
    // Calculate percentage value for the slider thumb position
    const percentageValue = (value / maxValue) * 100;
    document.documentElement.style.setProperty('--value', `${percentageValue}%`);
  }, [value, maxValue]);
  
  
  const [isBasicButtonDisabled, setisBasicButtonDisabled] = useState('');
  const [isProButtonDisabled, setisProButtonDisabled] = useState('');  
  const [isUltimateButtonDisabled, setisUltimateButtonDisabled] = useState('');


  const [PlanCreditsBasic, setPlanCreditsBasic] = useState('6,000');
  const [PlanPriceBasic, setPlanPriceBasic] = useState('0');
  const [PlanCreditsPremium, setPlanCreditsPremium] = useState('20,000');
  const [PlanPricePremium, setPlanPricePremium] = useState('2,699');
  const [CurrentCredit, setCurrentCredit] = useState('20,000');
  const [CurrentCurrency, setCurrentCurrency] = useState('INR');
  const [CurrentDuration, setCurrentDuration] = useState('Monthly');
  const [PlanPricePremiumINR, setPlanPricePremiumINR] = useState('2,699');
  const [PlanPricePremiumUSD, setPlanPricePremiumUSD] = useState('34');
  const [PlanPricePremiumGBP, setPlanPricePremiumGBP] = useState('');
  const [PlanCreditsUltimate, setPlanCreditsUltimate] = useState('20,000');
  const [PlanPriceUltimate, setPlanPriceUltimate] = useState('4,699');
  const [CurrencySymbol, setCurrencySymbold] = useState('₹ ');
  
  const handleChange = (event) => {
  const newValue = parseInt(event.target.value, 10);
  setValue(newValue);

  const newCredits = steps[newValue].toLocaleString('en-IN');
  let newCreditsWithoutComma = newCredits.replace(/,/g, '');

  setCurrentCredit(newCredits);

  if (newCreditsWithoutComma < 100001) {
    if(newCreditsWithoutComma === "20000"){
      if(currencyselectedOption === "INR"){
        setPlanPricePremium("$ 1,739");
        setPlanPricePremiumINR("1,739");
      } else if(currencyselectedOption === "USD"){
        setPlanPricePremium("$ 25");
        setPlanPricePremiumUSD("25");
      } else if(currencyselectedOption === "GBP"){
        setPlanPricePremium("$ 18");
        setPlanPricePremiumGBP("18");
      }
    }
    // Update premium pricing similarly for other ranges...
  }

  ChangePriceContent(newCredits, handlecurrencyselectedOption, handledurationselectedOption);
};

// Initialize the state for currency and duration
const [handlecurrencyselectedOption, sethandlecurrencyselectedOption] = useState("INR"); // Default to INR
const [handledurationselectedOption, sethandledurationselectedOption] = useState("Quarterly"); // Default to Monthly


const handlecurrencyChange = (event) => {
  const selectedOption = event.target.value;
  sethandlecurrencyselectedOption(selectedOption); // Update state
  // Use the updated value directly
  setCurrencySymbold("");
  ChangePriceContent(CurrentCredit, selectedOption, handledurationselectedOption);
};

const handledurationChange = (event) => {
  const selectedDuration = event.target.value;
  sethandledurationselectedOption(selectedDuration); // Update state
  // Use the updated value directly
  setCurrencySymbold("");
  // Use the updated value directly
  ChangePriceContent(CurrentCredit, handlecurrencyselectedOption, selectedDuration);
};



const ChangePriceContent = (credits, currency, duration) => {
  let newCreditsWithoutCommaa = credits.replace(/,/g, '');
  setCurrencySymbold("");
    setPlanCreditsPremium(credits);

	if(CurrentPlanId !== "" && CurrentPlanId !== null){
		setisBasicButtonDisabled(true);
	}

	setisProButtonDisabled(false);
	setisUltimateButtonDisabled(false);


	setselectedPlanIdPro("PRO002");
	setselectedPlanIdUltimate("ULT002");
	if(CurrentPlanId === "PRO002"){
		setisProButtonDisabled(true);
	}else if(CurrentPlanId === "ULT002"){
		setisUltimateButtonDisabled(true);
	}

	let level1Price = currency === 'INR' ? 2699 : 31.73;
	let checkpointPrice = currency === 'INR' ? 6829 : 80.28;
	let powermodePrice = currency === 'INR' ? 9599 : 112.84;

	let utilityConvPrice = currency === 'INR' ? 0.125 : 0.0015;
	let authConvPrice = currency === 'INR' ? 0.125 : 0.0015;
	let marketingConvPrice = currency === 'INR' ? 0.88 : 0.010;


	if (duration === "Yearly") {
		 level1Price = currency === 'INR' ? 9499 : 111.67;
		 checkpointPrice = currency === 'INR' ? 22799 : 268.02;
		 powermodePrice = currency === 'INR' ? 32999 : 387.92;

		 utilityConvPrice = currency === 'INR' ? 0.124 : 0.0015;
		 authConvPrice = currency === 'INR' ? 0.124 : 0.0015;
		 marketingConvPrice = currency === 'INR' ? 0.87 : 0.010;

		 setPlanDuration('Yearly');
	}else{
		setPlanDuration('Quarterly');
	}

	setPlanCurrency(`${currency === 'INR' ? '₹' : '$'}`);
	setPlanPriceLevel1(` ${Number(level1Price.toFixed(0)).toLocaleString('en-IN')}`);
	setPlanPriceCheckPoint(` ${Number(checkpointPrice.toFixed(0)).toLocaleString('en-IN')}`);
	setPlanPricePowerMode(` ${Number(powermodePrice.toFixed(0)).toLocaleString('en-IN')}`);

	setUtilityPrice(utilityConvPrice);
	setAuthenticationPrice(authConvPrice);
	setMarketingPrice(marketingConvPrice);

    


  	setPlanCreditsUltimate(credits);
  
};


  const currencyoptions = [
    { value: 'INR', label: 'INR', imgSrc: 'iconss/flags/india.png' },
    { value: 'USD', label: 'USD', imgSrc: 'iconss/flags/united-states.png' },
  ]; 
  
  const durationoptions = [
    { value: 'Quarterly', label: 'Quarterly'},
    { value: 'Yearly', label: 'Yearly', discount: ' -10% off'},
  ];  
  
  const ServerApiDomain = process.env.REACT_APP_SPRING_SERVER_API_DOMAIN;
	  
  const handleFreeAcountSubmit = async () => {
		

	const today = new Date(); // Today's date
	// Format date as "YYYY-MM-DDTHH:mm:ss.sssZ" (ISO 8601 format)
	const formatDate = (date) => {
	return date.toISOString();
	};

	// Generate resetData (tomorrow's date in YYYYMMDD format)
	
	today.setDate(today.getDate() + 1);  // Add one day to today's date

	const resetData = today.toISOString();

	// Generate purchaseDate (today's date in ISO format)
	const purchaseDate = formatDate(today);

	// Generate expirationDate (one year from today in ISO format)
	const expirationDate = formatDate(
	new Date(today.setFullYear(today.getFullYear() + 1))
	);

	const apiUrl = `${ServerApiDomain}/api/myplan/insertOrUpdate`;
	const data = {
	username: CookieAccountId,
	planId: "BASIC00",
	planName: "Basic Plan",
	paymentMonthly: 0,
	usedSubscribers: 0,
	totalSubscribers: 0,
	usedEmails: 0,
	totalEmails: 200,
	smsCredits: 0,
	usedUsers: 0,
	totalUsers: 0,
	resetData: resetData,
	purchaseDate: purchaseDate,
	expirationDate: expirationDate,
	status: "active",
	};

	try {
	  const response = await axios.post(apiUrl, data, {
		headers: {
		  "Content-Type": "application/json",
		},
	  });
	  console.log("API Response:"+ response.data);
	  window.location.href = `/dashboard`;
	} catch (error) {
	  console.log("Error while sending request:"+ error);
	}
  };
  

  return (
    <div className="email-plans-body">
		
		<div className="filters-area">
			<div className="row">
				
				<div className="col-12 col-md-12 col-lg-9 col-xl-9">
					   <div className="slider-container d-none">
							
							<input
								type="range"
								min="0"
								max={maxValue}
								value={value}
								className="range-slider"
								onChange={handleChange}
							/>
							 <div className="labels">
								<span className="current-value">{steps[value].toLocaleString('en-IN')}</span>
								<span className="max-value">{steps[maxValue].toLocaleString('en-IN')}</span>
							</div>
						</div>
				</div>
				<div className="col-12 col-md-12 col-lg-3 col-xl-3 float-end">
					<div className="row">
						<div className="col-5">
						

					<Select
					  style={{ height: '6.5vh'}}
					  value={handlecurrencyselectedOption} 
					  onChange={handlecurrencyChange}
										disableUnderline
										fullWidth
										defaultValue="All"
									  >
										{currencyoptions.map((option) => (
						<MenuItem key={option.value} value={option.value}>
						  <Box className="custom-typo" display="flex" alignItems="center">
							<img className="custom-select-icon" src={option.imgSrc} alt={option.label}  />
							<Typography className="custom-select-typography">{option.label}</Typography>
						  </Box>
						</MenuItem>
					  ))}
				  </Select>
						</div>
						<div className="col-7">
							
							  <Select
					  style={{ height: '6.5vh'}}
								  className="select-box" 
								  value={handledurationselectedOption} 
								  onChange={handledurationChange}
													disableUnderline
													fullWidth
													defaultValue="All"
												  >
									{durationoptions.map((option) => (
								  <MenuItem key={option.value} value={option.value}>
									<Box className="custom-typo" display="flex" alignItems="center">
									  <Typography className="custom-select-typography">{option.label}</Typography>
									  <span style={{ color: 'rgba(2,96,105)', fontWeight: '600', marginLeft: '0.5vw' }}>{option.discount}</span>
									</Box>
								  </MenuItem>
								))}
							  </Select>
							  
						</div>						
					</div>  
				</div>
			</div>
		</div>
		
		<div className="plans-column-area ">
			<div className="row d-flex horizontalrow">
				
			<div className="col-12 col-md-12 col-lg col-xl d-flex">
					<div className="plan-column w-100">
						<h3 className="plan-column-heading">Level 01</h3>
						<h6 className="plan-column-description">Unlimited agents (Owner Roles)</h6>
                        <h2 className='mt-3 fw-bold' style={{  fontSize: '28px', color: 'rgba(2,96,105)' }}><span >{PlanCurrency}</span> {PlanPriceLevel1} <span style={{fontWeight:'normal', color: 'rgba(100,100,100)'}}>/</span> <span style={{  fontSize: '16px', fontWeight:'normal', color: 'rgba(100,100,100)' }}>{PlanDuration}</span></h2>
						<div className="credits-area">
							
							<h6 className='pb-2 d-block'>Conversation Charges</h6>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-chat-dots"></i> Service</h6></div>
								<div className="col-5 right"><h6>FREE</h6></div>
							</div>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-bell"></i> Utility</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {UtilityPrice}</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-shield-lock"></i> Authentication</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {AuthenticationPrice}</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-megaphone"></i> Marketing</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {MarketingPrice}</h6></div>
							</div>

						</div>
						
					<div className="features-area">
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Omnichannel Inbox</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Unlimited Contacts</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Unlimited Team Members</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Campaign Report**</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> CTWA Ads Launcher</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Merchant Concierge</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Templates **</h5>
					</div>
					
					<div class="button-area"><button disabled={isProButtonDisabled} type="button" onClick={SelectProPlan} className="primary-outline-button">Select Plan</button></div>
					
					</div>
				</div>
				
				<div className="col-12 col-md-12 col-lg col-xl d-flex">
					<div className="plan-column w-100">
						<h3 className="plan-column-heading">Checkpoint</h3>
						<h6 className="plan-column-description">Unlimited agents (All Roles)</h6>
                        <h2 className='mt-3 fw-bold' style={{  fontSize: '28px', color: 'rgba(2,96,105)' }}><span >{PlanCurrency}</span> {PlanPriceCheckPoint} <span style={{fontWeight:'normal', color: 'rgba(100,100,100)'}}>/</span> <span style={{  fontSize: '16px', fontWeight:'normal', color: 'rgba(100,100,100)' }}>{PlanDuration}</span></h2>
						<div className="credits-area">
							
							<h6 className='pb-2 d-block'>Conversation Charges</h6>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-chat-dots"></i> Service</h6></div>
								<div className="col-5 right"><h6>FREE</h6></div>
							</div>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-bell"></i> Utility</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {UtilityPrice}</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-shield-lock"></i> Authentication</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {AuthenticationPrice}</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-megaphone"></i> Marketing</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {MarketingPrice}</h6></div>
							</div>

						</div>
						
					<div className="features-area">
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> All Level 01 Features</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> OOO/Delayed</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom Auto Replies</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Role and Permissions</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Link Button Tracking</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Sell Catalogue</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Webhooks</h5>
					</div>
					
					<div class="button-area"><button disabled={isProButtonDisabled} type="button" onClick={SelectProPlan} className="primary-outline-button">Select Plan</button></div>
					
					</div>
				</div>
				
				<div className="col-12 col-md-12 col-lg popular col-xl d-flex">
					<div className="plan-column w-100">
						<h3 className="plan-column-heading">Power Mode <span>Popular</span></h3>
						<h6 className="plan-column-description">Unlimited agents (All Roles)</h6>
                        <h2 className='mt-3 fw-bold' style={{  fontSize: '28px', color: 'rgba(2,96,105)' }}><span >{PlanCurrency}</span> {PlanPricePowerMode} <span style={{fontWeight:'normal', color: 'rgba(100,100,100)'}}>/</span> <span style={{  fontSize: '16px', fontWeight:'normal', color: 'rgba(100,100,100)' }}>{PlanDuration}</span></h2>
						<div className="credits-area">
							
							<h6 className='pb-2 d-block'>Conversation Charges</h6>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-chat-dots"></i> Service</h6></div>
								<div className="col-5 right"><h6>FREE</h6></div>
							</div>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-bell"></i> Utility</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {UtilityPrice}</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-shield-lock"></i> Authentication</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {AuthenticationPrice}</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-megaphone"></i> Marketing</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> {MarketingPrice}</h6></div>
							</div>

						</div>
						
					<div className="features-area">
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> All Checkpoint Features</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Auto Chat Routing</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Unlimited API Integrations</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> API Rate Limited (600/Min)	</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Order Related Webhooks</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> All Webhooks</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Brand Co-Pilot</h5>
					</div>
					
					<div class="button-area"><button disabled={isProButtonDisabled} type="button" onClick={SelectProPlan} className="primary-outline-button">Select Plan</button></div>
					
					</div>
				</div>
				
				<div className="col-12 col-md-12 col-lg col-xl d-flex">
				<div className="plan-column w-100">
						<h3 className="plan-column-heading">Custom Plan</h3>
						<h6 className="plan-column-description">Unlimited agents (All Roles)</h6>
                        <h2 className='mt-3 fw-bold' style={{  fontSize: '28px', color: 'rgba(2,96,105)' }}><span >{PlanCurrency}</span> -------- <span style={{fontWeight:'normal', color: 'rgba(100,100,100)'}}>/</span> <span style={{  fontSize: '16px', fontWeight:'normal', color: 'rgba(100,100,100)' }}>{PlanDuration}</span></h2>
						<div className="credits-area">
							
							<h6 className='pb-2 d-block'>Conversation Charges</h6>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-chat-dots"></i> Service</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> -------</h6></div>
							</div>

                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-bell"></i> Utility</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> -------</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-shield-lock"></i> Authentication</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> -------</h6></div>
							</div>

                            
                            <div className="row align-items-center">
								<div className="col-7 left"><h6><i className="bi bi-megaphone"></i> Marketing</h6></div>
								<div className="col-5 right"><h6><span style={{ fontFamily: 'Monaco' }}>{PlanCurrency}</span> -------</h6></div>
							</div>

						</div>
						
					<div className="features-area">
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> All Power ModePopular</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom Auto Chat Routing</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom API Integrations</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom API Rate Limited	</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom Dedicated Template</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom Webhooks</h5>
						<h5 className="feature-list"><i class="bi bi-check-circle-fill"></i> Custom Support</h5>
					</div>
					
					<div class="button-area"><a href="/contact" target="_blank" className="primary-outline-button d-block text-center text-decoration-none">Contact Sales</a></div>
					
					</div>
				</div>
				
			</div>
		</div>
		
		<div className="feature-comparision-area">
			<h3 className="heading">Transparency at its Best!</h3>
			<h6 className="description">Explore the features and benefits of each package side by side to make an informed decision. <a target="_blank" className="a-link" href="/contact">We're here to help.</a></h6>
			<div className="table-container ">
			  <table>
				<thead>
				  <tr>
					<th>Features</th>
					<th>Basic</th>
					<th>Pro</th>
					<th>Business</th>
					<th>Custom</th>
				  </tr>
				</thead>
				<tbody>
					 
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Omnichannel Inbox</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Unlimited Contacts</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Unlimited Team Members</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Campaign Report**</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Campaign Filter</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> CTWA Ads Launcher</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Merchant Concierge</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>


					  
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Whatsapp Widgets</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>


					  
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Templates</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Whatsapp Analytics</span></td>
						<td class="fourth_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> OOO/Delayed</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>




					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Custom Auto Replies</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>





					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Role and Permissions</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>




					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Link Button Tracking</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Sell Catalogue</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Webhooks</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> API Rate Limit</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td">300/MIN</td>
						<td class="third_td">600/MIN</td>
						<td class="fifth_td">UPTO 1000/MIN</td>
					  </tr>
					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Whatsapp Payments</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> App Integration</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td">3</td>
						<td class="third_td">5</td>
						<td class="fifth_td">UPTO 10</td>
					  </tr>

					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Auto Chat Routing</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  

					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Unlimited API Integrations</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  

					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Order Related Webhooks</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>

					  

					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> All Webhooks</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>
					  

					  
					  <tr class="tr">
						<td class="first_td" >
						<span data-toggle="tooltip" data-placement="right" title="Effortlessly create campaigns with AI features"> Brand Co-Pilo</span></td>
						<td class="fourth_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="second_td"><i class="bi bi-x-circle-fill"></i></td>
						<td class="third_td"><i class="bi bi-check-circle-fill"></i></td>
						<td class="fifth_td"><i class="bi bi-check-circle-fill"></i></td>
					  </tr>
					  
	  
				</tbody>
			  </table>
			</div>
		
		</div>
		
		
		<div className="faqss-area">
			<h3 className="heading">Frequently asked questions</h3>
			<h6 className="description">Have doubts about our plan? Don't worry we got you cover</h6>
			
			<div className="accordion">
			  {faqs.map((faq, index) => (
				<div key={index} className="faq-item">
				  <div
					className={`faq-question ${activeIndex === index ? 'active' : ''}`}
					onClick={() => toggleFAQ(index)}
				  >
					{faq.question}
					<span className={`arrow ${activeIndex === index ? 'rotate' : ''}`}>
					  <i class="bi bi-chevron-down"></i>
					</span>
				  </div>
				  <div className={`faq-answer ${activeIndex === index ? 'open' : ''}`}>
					{faq.answer}
				  </div>
				</div>
			  ))}
		</div>
			
		</div>

		
    </div>
  );
};

export default WhatsappMarketingPlans;